import i18n from './i18n';
const { t } = i18n;
const reg = /\{#[^]+#\}/;
console.log((i18n));
export const $t = (key: string, args: any = {}): string => {
    return  key && reg.test(key) ? t(key.slice(2, -2), {...args}) : key;
}
